// DocumentViewer version (the one we want)
import { DocumentViewer } from "~/shared/components/document-viewer/document-viewer.tsx";
import type { Invoice } from "~/shared/schemas/invoice-schema";
import type { DefaultDocument } from "~/shared/types/payment-types";

type PaymentDocumentViewerProps = {
	selectedInvoice: Invoice | null;
	viewerState: {
		isOpen: boolean;
		selectedDocument: DefaultDocument | null;
	};
	onClose: () => void;
	onSelectDocument: (doc: DefaultDocument) => void;
};

export function PaymentDocumentViewer({
	selectedInvoice,
	viewerState,
	onClose,
	onSelectDocument,
}: Readonly<PaymentDocumentViewerProps>) {
	return (
		<DocumentViewer
			onClose={onClose}
			onSelectDocument={onSelectDocument}
			poNumber={selectedInvoice?.poNumber ?? undefined}
			viewerState={viewerState}
		/>
	);
}
